import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import OrganizationChildResources from "OrganizationResources/routes/OrganizationChildResouces";
export default store => ({
  path: "resources",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "unit-planner" */ "./components"),
        import(
          /* webpackChunkName: "unit-planner" */ "OrganizationResources/modules/OrganizationResourcesModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const orgResourcesReducer = importedModule1.default;
        injectReducer(store, {
          key: "organizationResource",
          reducer: orgResourcesReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [OrganizationChildResources(store)],
});
